module.exports = __webpack_public_path__ + "static/media/animation_Icon.d3510ea3.gif";